import React, { useState, useMemo, useEffect } from "react";
import { ready } from "../../util/icon";
import { useDispatch, useSelector } from "react-redux";
import {
  getNewStatusFetch,
  putFinishStatusFetch,
} from "../../features/action/fetchStatus";
import { search, sortDate } from "../../util/sort";
import { checkIsName } from "../../features/redux/authSlice";
import { useSearch } from "../../context/SearchContext";
import { Button } from "../../util/main";
import { FaBoxes } from "react-icons/fa";
import { putUpdateKeeper } from "../../features/action/fetchKeeper";
import { Disigner } from "./Disigner";
import { Storage } from "./Storage";
import Tables from "./Tables";

const Keeper = () => {
  const { manager } = useSelector((state) => state.status);
  const dispatch = useDispatch();
  const [filteredStatus, setFilteredStatus] = useState([]);
  const [number, setNumber] = useState(null);
  const [line, setLine] = useState(null);
  const { searchQuery } = useSearch();
  const user = useSelector(checkIsName);
  const memoizedUser = useMemo(() => user, [user]);
  const [openTables, setOpenTables] = useState({});
  const [confirmId, setConfirmId] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    key: "toDate",
    isAscending: false,
  });

  const toggleTable = (orderSH) => {
    console.log(orderSH);

    setOpenTables((prev) => ({
      ...prev,
      [orderSH]: !prev[orderSH],
    }));
  };

  const handleClickEnd = (id, order) => {
    setConfirmId({ id, order });
  };

  const handleConfirm = () => {
    dispatch(putFinishStatusFetch(confirmId.id, memoizedUser.username));
    setConfirmId(null);
  };
  const handleClickStatus = (id) => {
    dispatch(putUpdateKeeper(id, number, line));
    setNumber(null);
    setLine(null);
  };

  const getArrowClass = (key, isAsc) => {
    const isActive =
      sortConfig?.key === key && sortConfig?.isAscending === isAsc;
    return `cursor-pointer px-1 ${
      isActive ? "text-black font-bold" : "text-[#9E9E9E] hover:text-black"
    }`;
  };

  // Сортировка по дате завершения
  const handleToDate = (manualAscending) => {
    const isAscending =
      typeof manualAscending === "boolean"
        ? manualAscending
        : sortConfig.key === "toDate"
          ? !sortConfig.isAscending
          : false;
    setSortConfig({ key: "toDate", isAscending });
  };

  useEffect(() => {
    dispatch(getNewStatusFetch());
  }, [dispatch]);

  useEffect(() => {
    document.body.classList.add("no-scrollbar");
    document.documentElement.classList.add("no-scrollbar");
    return () => {
      document.body.classList.remove("no-scrollbar");
      document.documentElement.classList.remove("no-scrollbar");
    };
  }, []);

  useEffect(() => {
    let filteredResults = searchQuery ? search(manager, searchQuery) : manager;
    if (sortConfig.key) {
      filteredResults = sortDate(
        [...filteredResults],
        sortConfig.key,
        sortConfig.isAscending,
      );
    }
    setFilteredStatus(filteredResults);
  }, [searchQuery, manager, sortConfig]);

  return (
    <div className="w-[100%]">
      {confirmId && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-xl shadow-2xl p-6 flex flex-col items-center gap-4 min-w-[260px]">
            <p className="font-rubik text-[#7D7D7D] text-base">Close order <span className="font-semibold text-[#739D00]">#{confirmId.order}</span>?</p>
            <div className="flex gap-3">
              <button onClick={handleConfirm} className="px-5 py-1.5 bg-[#e6e6e6] hover:bg-[#739D00] text-[#7D7D7D] hover:text-white font-rubik rounded-lg transition-colors">Confirm</button>
              <button onClick={() => setConfirmId(null)} className="px-5 py-1.5 bg-[#e6e6e6] hover:bg-[#739D00] text-[#7D7D7D] hover:text-white font-rubik rounded-lg transition-colors">Cancel</button>
            </div>
          </div>
        </div>
      )}
      <div className="flex flex-col  mx-auto">
        {/* Заголовки */}
        <div className="flex flex-row  w-full my-4 text-center text-[#9E9E9E] text-base mx-auto ">
          <button className="w-[10%] ">
            <span
              className={getArrowClass("toDate", true)}
              onClick={() => handleToDate(true)}
            >
              ▲
            </span>
            to
            <span
              className={getArrowClass("toDate", false)}
              onClick={() => handleToDate(false)}
            >
              ▼
            </span>
          </button>
          <div className="w-[18%] ">team members</div>
          <div className="w-[28%] ">order</div>
          <div className="w-[34%] ">place</div>
          <div className="w-[10%] ">finish</div>
        </div>
        <div className="rounded-xl mb-6">
          {filteredStatus.map((i) => (
            <React.Fragment key={i._id}>
              <div className="flex flex-col h-[64px] mb-0.5 text-center rounded-[10px] bg-white border-solid border-[1px] border-[#dbdbdb] overflow-hidden">
                <div className="flex flex-row h-[64px] w-full">
                  {/* ----------------------------------------Block Number Order----------------------------------------------------- */}
                  {i.place.trim() !== "הזמנות למחסן" ? (
                    <Disigner
                      i={i}
                      setNumber={setNumber}
                      setLine={setLine}
                      onToggle={() => toggleTable(i._id)}
                      isName={user}
                    />
                  ) : (
                    <Storage
                      i={i}
                      setNumber={setNumber}
                      setLine={setLine}
                      onToggle={() => toggleTable(i._id)}
                      isName={user}
                    />
                  )}
                  {/* ---------------------------------------Button End-------------------------------------------------- */}
                  {i.studio.ready === true
                    ? Button(ready, () => handleClickEnd(i._id, i.order))
                    : Button(
                        <FaBoxes className="text-white text-[1.6vw]" />,
                        () => handleClickStatus(i._id),
                      )}
                </div>
              </div>
              {openTables[i._id] && i.tableSH && <Tables i={i.tableSH} />}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Keeper;
